import { render, staticRenderFns } from "./BarAndLing.vue?vue&type=template&id=10ac2551&scoped=true&"
import script from "./BarAndLing.vue?vue&type=script&lang=js&"
export * from "./BarAndLing.vue?vue&type=script&lang=js&"
import style0 from "./BarAndLing.vue?vue&type=style&index=0&id=10ac2551&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac2551",
  null
  
)

export default component.exports